import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAU2vDDiNdarEPq3n6REeM2Jkt5IYjS3Zg",
  authDomain: "brix-v2.firebaseapp.com",
  projectId: "brix-v2",
  storageBucket: "brix-v2.firebasestorage.app",
  messagingSenderId: "942109742957",
  appId: "1:942109742957:web:5cab85e7c73441f87d2c64",
  measurementId: "G-D6Q1J3HLSG"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

export { app, analytics, db, auth, storage }; 